/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";
import { hideNavBar } from "@/common/common.js";

export function InitializeProgramSelectionPage() {
  customValidationInit(false);
  aspControlValidationInit();

  hideNavBar();
}
